export const initialState = {
  students: 0,
  groups: 0,
  undergraduate: 0,
  postgraduate: 0,
  regular: 0,
  extension: 0,
  tab: 0,
  load: 0,
  showDepartments: false,
  showColleges: false,
  action: 1,

  selectedCollege: "",
  selectedDepartment: "",
  selectedSemester: "",
  selectedTerm: "",

  currentTerm: [],

  colleges: [],
  departments: [],
  semesters: [],

  tableHeader: "",
  tableColumn: [],
  tableData: [],
};
